
import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

export default function Loader() {
    return (
        <div className="card justify-content-center">
            <div className="flex justify-content-center">
                <ProgressSpinner /> 
            </div>
            <div className="flex justify-content-center">
                <p>Cargando...</p>
            </div>
        </div>
    );
}
        